+/**
 * Cookie Banner
 */

/*
 Connections:
 -------------------------------------------------------------------------------
 * google - GA4, Google Ads
 * facebook - Meta Pixel
 * players - every player on website: YouTube, Vimeo
 * marketing - chat, Convertbox
 * 
*/

(function ($) {
    var config = {
        debugMode: true,
        userConsents: {
            google: false,
            facebook: false,
            players: false,
            marketing: false
        },
        userUUID: 'not-set',
        groups: [
            'google',
            'facebook',
            'players',
            'marketing'
        ],
        allowedGroups: []
    };
  
    var UI = {
        basicWindow: $('.mwf-cn-info'),
        extendedWindow: $('.mwf-cn-info-extended'),
        buttons: {
            basicShowExtended: $('.mwf-cn-info-button-show-extended'),
            basicAcceptAll: $('.mwf-cn-info-button-accept-all'),
            basicRejectAll: $('.mwf-cn-info-button-reject-all'),
            extendedAcceptAll: $('.mwf-cn-info-extended-button-accept-all'),
            extendedSaveConfig: $('.mwf-cn-info-extended-button-save-consent'),
            extendedNotNow: $('.mwf-cn-info-extended-button-close-without-save')
        },
        checkboxes: {
            google: $('.mwf-cn-consent-checkbox[data-consent-type="google"]'),
            facebook: $('.mwf-cn-consent-checkbox[data-consent-type="facebook"]'),
            players: $('.mwf-cn-consent-checkbox[data-consent-type="players"]'),
            marketing: $('.mwf-cn-consent-checkbox[data-consent-type="marketing"]')
        }
    };
  
    if (UI.basicWindow.length) {
        initEvents();
        initPublicAPI();
        checkConfig(config);
    }
  
    function checkConfig () {
        var configFromCookie = Cookies.get(window.mwfCNConfig.cookieName, { path: window.mwfCNConfig.path });
  
        // When no config - show popup
        if (!configFromCookie) {
            if (config.debugMode) {
                console.log('⛔️ Consent config not found - showing popup');
            }
    
            config.userUUID = generateUUID();
            
            // Not open on privacy policy page
            if (!$(document.body).hasClass('privacy-policy')) {
                showPopup();
            }

            return;
        }
  
        // otherwise - load config without showing popup
        loadConfig(configFromCookie);
    }
  
    function loadConfig (configFromCookie) {
        config.userConsents.google = configFromCookie.indexOf('google') > -1;
        config.userConsents.facebook = configFromCookie.indexOf('facebook') > -1;
        config.userConsents.players = configFromCookie.indexOf('players') > -1;
        config.userConsents.marketing = configFromCookie.indexOf('marketing') > -1;
        let configParts = configFromCookie.split('||');

        if (configParts[1]) {
            config.userUUID = configParts[1].replace(/[^a-zA-Z0-9\-]/gmi, '');
        } else {
            config.userUUID = generateUUID();
        }
  
        for (var i = 0; i < config.groups.length; i++) {
            var groupName = config.groups[i];
  
            if (config.userConsents[groupName]) {
                config.allowedGroups.push(groupName);
            }
        }
  
        if (config.debugMode) {
            console.log('⚙️ Founded config:', JSON.parse(JSON.stringify(config.userConsents)));
        }
    }
  
    function initEvents () {
        $(document).find('a[href="#cookie-settings"]').on('click', e => {
            e.preventDefault();
            showExtendedPopup();
        });
  
        UI.buttons.basicShowExtended.on('click', e => {
            e.preventDefault();
            closePopup();
            showExtendedPopup();
        });
  
        UI.buttons.basicAcceptAll.on('click', e => {
            e.preventDefault();
            giveConsentForAll();
            closePopup();
        });
  
        UI.buttons.basicRejectAll.on('click', e => {
            e.preventDefault();
            resetCookieConfig();
            closePopup();
        });
  
        UI.buttons.extendedAcceptAll.on('click', e => {
            e.preventDefault();
            giveConsentForAll();
            closeExtendedPopup();
        });
  
        UI.buttons.extendedSaveConfig.on('click', e => {
            e.preventDefault();
            saveConsent();
            closeExtendedPopup();
        });
  
        UI.buttons.extendedNotNow.on('click', e => {
            e.preventDefault();
            closeExtendedPopup();

            var configFromCookie = Cookies.get(window.mwfCNConfig.cookieName, { path: window.mwfCNConfig.path });
  
            if (!configFromCookie) {
                showPopup();
            }
        });
    }
  
    function setCheckboxes () {
        for (var i = 0; i < config.groups.length; i++) {
            var group = config.groups[i];
  
            if (config.userConsents[group]) {
                UI.checkboxes[group].prop('checked', true);
            } else {
                UI.checkboxes[group].prop('checked', false);
            }
        }
    }
  
    function initPublicAPI () {
        window.mwfCookieBanner = {
            giveConsentAndSave: function (type) {
                giveConsentAndSave(type);
            },
            giveConsentAndSaveAndLoad: function (type) {
                giveConsentAndSave(type, true);
            },
            showExtendedPopup: function () {
                showExtendedPopup();
            },
            getConsentStatus: function (type) {
                getConsentStatus(type);
            }
        };
    }
  
    function showPopup () {
        UI.basicWindow.removeClass('is-hidden');
    }
  
    function closePopup () {
        UI.basicWindow.addClass('is-hidden');
    }
  
    function showExtendedPopup () {
        UI.extendedWindow.removeClass('is-hidden');
        $(document.body).addClass('no-scroll');
        setCheckboxes();
    }
  
    function closeExtendedPopup () {
        UI.extendedWindow.addClass('is-hidden');
        $(document.body).removeClass('no-scroll');
    }
  
    function giveConsentForAll () {
        giveConsent('google');
        giveConsent('facebook');
        giveConsent('players');
        giveConsent('marketing');
        saveConsentConfigInCookie(false);
    }
  
    function giveConsent (type, forceOnLoad = false) {
        if (config.debugMode) {
            console.log('✅ User gave consent:', type);
        }
  
        // If consent has been previously given - do nothing
        if (config.allowedGroups.indexOf(type) > -1) {
            return;
        }
  
        config.userConsents[type] = true;

        if (type === 'google') {
            allowGoogle();
            return;
        }

        if (type === 'facebook') {
            allowFB();
            return;
        }
  
        if (type === 'players') {
            allowPlayers();
            return;
        }
  
        if (type === 'marketing') {
            allowMarketing();
            return;
        }
    }
  
    function giveConsentAndSave (type, forceOnLoad = false) {
        giveConsent(type, forceOnLoad);
        saveConsentConfigInCookie(false);
    }
  
    function saveConsent () {
        var consentCompare = compareConsents();
        setConsentBasedOnCheckboxes();
  
        // if some consent has been removed
        if (consentCompare === 'some-rejected') {
            saveConsentConfigInCookie(true);
            return;
        }
  
        // otherwise - if some consent has been added
        saveConsentConfigInCookie(false);
    }
  
    function setConsentBasedOnCheckboxes () {
        for (var i = 0; i < config.groups.length; i++) { 
            var group = config.groups[i];
  
            if (!!UI.checkboxes[group].prop('checked')) {
                giveConsent(group);
            }
  
            config.userConsents[group] = !!UI.checkboxes[group].prop('checked');
        }
    }
  
    function saveConsentConfigInCookie (reloadNeeded = false) {
        var configToSave = [];
  
        for (var i = 0; i < config.groups.length; i++) {
            var group = config.groups[i];
  
            if (config.userConsents[group]) {
                configToSave.push(group);
            }
        }
  
        if (configToSave.length) {
            Cookies.set(window.mwfCNConfig.cookieName, configToSave.join(';') + '||' + config.userUUID, { expires: 180, path: window.mwfCNConfig.path });
  
            if (config.debugMode) {
                console.log('🍪 Consent config saved in the cookie');
            }
        } else {
            Cookies.set(window.mwfCNConfig.cookieName, 'null' + '||' + config.userUUID, { expires: 180, path: window.mwfCNConfig.path });
        }

        let dataToSave = {
            consent_id: config.userUUID,
            consent_revision: window.mwfCNConfig.cookieName,
            consent_content: configToSave.join(';'),
            consent_timestamp: +new Date(),
            url: window.location.pathname,
            delivery: 'sendBeacon' in navigator ? 'beacon' : 'ajax'
        };
      
        if ('sendBeacon' in navigator) {
            const formData = $.param(dataToSave);
            const blob = new Blob(
                [formData], 
                {
                    type : 'application/x-www-form-urlencoded'
                }
            );
            navigator.sendBeacon('https://malawielkafirma.pl/wp-json/cmp/v1/save', blob);
            
            if (reloadNeeded) {
                setTimeout(() => {
                    window.location.reload();
                }, 500);
            }
        } else {
            $.ajax({
                url: 'https://malawielkafirma.pl/wp-json/cmp/v1/save',
                type: 'POST',
                contentType: 'application/x-www-form-urlencoded',
                data: $.param(dataToSave),
                success: function () {
                    if (reloadNeeded) {
                        setTimeout(() => {
                            window.location.reload();
                        }, 500);
                    }
                },
                fail: function () {
                    if (reloadNeeded) {
                        setTimeout(() => {
                            window.location.reload();
                        }, 500);
                    }
                }
            });
        }
    }
  
    function resetCookieConfig () {
        Cookies.set(window.mwfCNConfig.cookieName, 'null' + '||' + config.userUUID, { expires: 180, path: window.mwfCNConfig.path });
  
        if (config.debugMode) {
          console.log('🗑 User rejected all cookies - save empty config cookie');
        }

        let dataToSave = {
            consent_id: config.userUUID,
            consent_revision: window.mwfCNConfig.cookieName,
            consent_content: '',
            consent_timestamp: +new Date(),
            url: window.location.pathname,
            delivery: 'sendBeacon' in navigator ? 'beacon' : 'ajax'
        };
      
        if ('sendBeacon' in navigator) {
            const formData = $.param(dataToSave);
            const blob = new Blob(
                [formData], 
                {
                    type : 'application/x-www-form-urlencoded'
                }
            );
            navigator.sendBeacon('https://malawielkafirma.pl/wp-json/cmp/v1/save', blob);
        } else {
            $.ajax({
                url: 'https://malawielkafirma.pl/wp-json/cmp/v1/save',
                type: 'POST',
                contentType: 'application/x-www-form-urlencoded',
                data: $.param(dataToSave)
            });
        }
    }
  
    function compareConsents () {
        var someRejected = false;
  
        for (var i = 0; i < config.groups.length; i++) {
            var group = config.groups[i];
  
            if (config.userConsents[group] && !UI.checkboxes[group].prop('checked')) {
                someRejected = true;

                if (group === 'google' && typeof gtag === 'function') {
                    gtag('consent', 'update', {
                        ad_user_data: 'denied',
                        ad_personalization: 'denied',
                        ad_storage: 'denied',
                        analytics_storage: 'denied'
                    });
                }
            }
        }
  
        if (someRejected) {
            if (config.debugMode) {
                console.log('🔄 Some consents has been rejected - website reload needed');
            }
  
            return 'some-rejected';
        }
  
        if (config.debugMode) {
            console.log('ℹ️ User not rejected any consents - website reload not needed');
        }
  
        return 'some-added-or-not-changed';
    }
  
    function getConsentStatus (type) {
        return !!config.userConsents[type];
    }
  
    function allowGoogle () {
        if (window.mwfUnlocked.indexOf('google') > -1) {
            return;
        }
  
        window.mwfUnlockConsentedScript('google', 'head', true);
    }

    function allowFB () {
        if (window.mwfUnlocked.indexOf('facebook') > -1) {
            return;
        }
    
        window.mwfUnlockConsentedScript('facebook', 'head', true);
    }
    
    function allowPlayers () {
        if (window.mwfUnlocked.indexOf('players') > -1) {
            return;
        }
  
        window.mwfUnlockPlayers(true);
    }
    
    function allowMarketing () {
        if (window.mwfUnlocked.indexOf('marketing') > -1) {
            return;
        }
  
        window.mwfUnlockConsentedScript('marketing', 'head', true);
        window.mwfUnlockMarketing(true);
    }

    function generateUUID () {
        var crypto = window.crypto || window.msCrypto;
    
        if (crypto && crypto.randomUUID) {
            let uuid = crypto.randomUUID();
            return uuid;
        }
    
        if (window.Uint8Array && crypto && crypto.getRandomValues) {
            let bytes = new Uint8Array(16);
            crypto.getRandomValues(bytes);
            bytes[6] = (bytes[6] & 0x0f) | 0x40;
            bytes[8] = (bytes[8] & 0x3f) | 0x80;
            let uuid = Array.prototype.map.call(bytes, (b, i) => {
                return ((b < 16) ? '0' : '') + b.toString(16) + (((i % 2) && (i < 10) && (i > 2)) ? "-" : "");
            }).join('');
            return uuid;
        }
    
        var dt = new Date().getTime();
        var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = (dt + Math.random()*16)%16 | 0;
            dt = Math.floor(dt/16);
            return (c == 'x' ? r : (r&0x3|0x8)).toString(16);
        });
    
        return uuid;
    }
  })(jQuery);